<template>
    <BreadCrumb PageTitle="Liste type de Document" />
    <ListeTypeDocument />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeTypeDocument from "@/components/TypeDocument/ListeTypeDocument.vue";

export default defineComponent({
    name: "ListeTypeDocumentPage",
    components: {
        BreadCrumb,
        ListeTypeDocument,
    },
});
</script>